import {ConversationEventType} from '@stripe-internal/conversations-client';

type TransitionContext = {
  channel?: unknown;
  chat_conversationId?: unknown;
  requestedChannel?: unknown;
  intent?: unknown;
  requestACallDetails?: unknown;
  emailDetails?: unknown;
};

/**
 * Emits a `conversation-set-context-values` event carrying the channel that a
 * server-driven `terminate_conversation` part moved the conversation into, so the
 * UI transitions (chat connect / request-a-call widget) reactively rather than
 * only after a full reload. Shared by the send-message and submit-message-part
 * response paths so they cannot drift.
 */
export function emitChannelTransitionContext(
  emitConversationEvent: (event: ConversationEventType) => void,
  conversationId: string,
  context: TransitionContext,
): void {
  if (typeof context.channel !== 'string' || context.channel === 'bot') {
    return;
  }

  const values: Record<string, unknown> = {
    channel: context.channel,
    requestedChannel:
      typeof context.requestedChannel === 'string'
        ? context.requestedChannel
        : context.channel,
    intent:
      typeof context.intent === 'string' ? context.intent : 'contact_support',
  };

  if (
    context.channel === 'chat' &&
    typeof context.chat_conversationId === 'string' &&
    context.chat_conversationId
  ) {
    values.chat_conversationId = context.chat_conversationId;
  }

  if (context.channel === 'request_a_call' && context.requestACallDetails) {
    values.requestACallDetails = context.requestACallDetails;
  }

  if (context.channel === 'email' && context.emailDetails) {
    values.emailDetails = context.emailDetails;
  }

  emitConversationEvent({
    name: 'conversation-set-context-values',
    conversationId,
    values,
  });
}
